import localforage from 'localforage';
export var getOrCreateDBTable = function (storeName) {
    return localforage.createInstance({
        name: 'Uspacy',
        storeName: storeName,
    });
};
